(ns kyber.components.composite.pdftron-viewer
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]

   [kyber.styles.core :refer [styles->classes]]
   [kyber.utils :refer [gen-cid]]))

(def classes
  (styles->classes
   {:pdftron-viewer-container
    {:transition "width 0.4s ease-in-out, height 0.4s ease-in-out"}}))

(defn render
  [pdf {:keys [viewer-key] :as options}]
  (let [!ref (atom nil)]
    (reagent/create-class
     {:component-did-mount
      (fn []
        (let [ecid (gen-cid)]
          (re-frame/dispatch [:analytics/set-event-context
                              {:ecid ecid
                               :event-context
                               {:viewer-key viewer-key
                                :resource-uuid (:uuid pdf)}}])

          (re-frame/dispatch
           [:pdftron-viewer/initialize-pdftron pdf (assoc options
                                                          :container @!ref
                                                          :ecid ecid)])))
      :reagent-render
      (fn [_ {:keys [styles] :or {styles {}}}]
        [:div {:class (:pdftron-viewer-container classes)
               :style (merge {:width "100%"
                              :height "100%"}
                             styles)
               :ref #(reset! !ref %)}])})))
